export class LoadSearchEvents {
  static readonly type = '[LoadSearchEvents] Load Search Events';

  constructor(readonly filter: string) {}
}
